import React from "react";
import {
  FaTrophy,
  FaUsers,
  FaRegHandshake,
  FaRegBuilding,
} from "react-icons/fa"; // Importing icons from react-icons

const CompanyHistory = () => {
  return (
    <>
      <div className='flex flex-col lg:flex-row py-4'>
        {/* Left Section - History */}
        <div className=' px-4 lg:mb-0 text-justify'>
          <h2 className='text-2xl underline md:text-3xl font-bold mb-4 text-center'>
            Shiva Group: A Legacy of Trust
          </h2>
          <p className='mb-4'>
            Shiva Group has over the years evolved as a leading Automotive
            conglomerate consisting of Five Authorized Dealerships representing
            prominent brands like Bajaj, Hyundai, Ford, Chetak Electric and
            Triumph. Our diverse portfolio of dealerships enables us to offer
            2-wheelers, 4-wheelers, and EVs to our customers.
          </p>
          <p className=''>
            With a rapidly expanding network of Showrooms and Service Workshops
            across Aligarh District, Shiva Group is striving to ensure
            unparalleled accessibility of our vast range of vehicle options to
            our customers with a seamless and convenient buying experience.
          </p>
        </div>
      </div>
      <div className='py-2'>
        <div className='text-center px-4 text-justify'>
          <h2 className='text-2xl underline md:text-3xl font-bold mb-4 text-center'>
            Our Journey
          </h2>
          <p className='mb-2 text-md '>
            At Shiva Group, our journey began approximately Five decades ago
            when our founder Chairman, Shri Shiv Kumar Mittal, an engineer from
            AMU in 1972, started the Dealership of Indian Oil Corporation’s for
            Petroleum products. Along with taking the Petroleum Dealership to
            new heights, in the year 1978 expanded the business base with the
            dealership of Bajaj Auto Ltd. The same values have been carried
            forward by our Managing Director, Shri Shalabh Mittal and Director,
            Shri Saumitra Mittal.
            <br />
            In 2013, we got the opportunity to expand our business as an
            Authorised Dealers for Hyundai Motor India Ltd. For their 4-wheeler
            products. We started the business full heartedly. The passion and
            commitment for delivering exceptional quality vehicles and
            outstanding customer service has enabled us grow into Five
            authorized dealerships across multiple regions.
          </p>
          <p className='mb-4 text-md '>
            Guided by our core values, we've built long-lasting relationships
            with our customers. Today, with over 50 years of experience, we
            proudly stand as one of the most trusted names in the automotive
            industry in Aligarh. Over the years we have received so many
            Credentials and Awards from the automotive companies for exceptional
            customer service. These achievements and awards however would not
            have been possible without the love of our customers and the support
            of our employees.
            <br />
            We are committed to contribute to various charitable and social
            service organizations to make a positive impact on the Aligarh area.
            As we look to the future, we're excited to continue our shared
            legacy, achieve new milestones, and grow together – all while
            prioritizing the satisfaction and loyalty of our customers.
          </p>
        </div>
      </div>
    </>
  );
};

export default CompanyHistory;
